import { useState } from "react";
import FirebaseKey from "../../components/FirebaseKey/FirebaseKey";
import PageLayout from "../../components/Layout/PageLayout";
import FirebaseService from "../../core/services/firebase.service";

const FAQ = () => {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  const questions = FirebaseService.getStringArray(
    FirebaseService.faq_questions
  );
  const answers = FirebaseService.getStringArray(FirebaseService.faq_answers);

  const toggleItem = (id: number) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <PageLayout>
      <div className="pb-4">
        <h2 className="text-[32px] font-medium text-black text-start">
          <FirebaseKey firebaseKey={FirebaseService.faq_header} />
        </h2>
      </div>
      <div className="mx-auto w-full">
        <div className="bg-[#F5F4F2] rounded-3xl overflow-hidden">
          {questions.map((question, index) => {
            const isExpanded = expandedId === index;
            const answer = answers[index] || "";
            return (
              <div
                key={index}
                className={`border-b border-[#E0E0E0] last:border-b-0 ${
                  isExpanded ? "" : ""
                }`}
              >
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full p-2 flex items-start justify-between text-left transition-colors"
                >
                  <div className="px-4 pt-2">
                    <span className="font-medium text-black">{question}</span>
                    {isExpanded && answer && (
                      <div className="">
                        <p className="text-[#43424299] text-sm font-medium leading-tight">
                          {answer}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="flex-shrink-0 ml-4">
                    <button
                      className="w-10 h-10 rounded-full bg-[#807e7d1f] flex items-center justify-center text-black hover:bg-gray-300 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleItem(index);
                      }}
                    >
                      {isExpanded ? (
                        <span className="text-lg font-medium">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 12L18 12"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      ) : (
                        <span className="text-lg font-medium">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="4.97501"
                              y="12.75"
                              width="1.5"
                              height="14"
                              rx="0.75"
                              transform="rotate(-90 4.97501 12.75)"
                              fill="black"
                            />
                            <rect
                              x="11.225"
                              y="5"
                              width="1.5"
                              height="14"
                              rx="0.75"
                              fill="black"
                            />
                          </svg>
                        </span>
                      )}
                    </button>
                  </div>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </PageLayout>
  );
};

export default FAQ;
